"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CURRENT_MAP_FOR_STORE = void 0;
var client_1 = require("@apollo/client");
exports.GET_CURRENT_MAP_FOR_STORE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetCurrentMapForStore($storeId: ID!) {\n    currentStoreMap(storeId: $storeId) {\n      id\n      geoJson\n      store {\n        id\n      }\n    }\n  }\n"], ["\n  query GetCurrentMapForStore($storeId: ID!) {\n    currentStoreMap(storeId: $storeId) {\n      id\n      geoJson\n      store {\n        id\n      }\n    }\n  }\n"])));
var templateObject_1;
